!function(){"use strict";function DcyNgRepeatEnd($timeout){return{restrict:"A",link:function(scope,element,attr){!0===scope.$last&&$timeout(function(){scope.$emit("dcy.ngRepeat.end")})}}}DcyNgRepeatEnd.$inject=["$timeout"],angular.module("dcyApp.directives").directive("dcyNgRepeatEnd",DcyNgRepeatEnd)}();
//# sourceMappingURL=ng_repeat_end.directive.js.map
;
